<template>
  <aha-modal
    title="Don’t lose out!"
    ref="remove-card-info-popup"
    id="remove-card-info-popup"
    v-if="visible"
    @hide="handleCancelButton()"
  >
    <img
      src="@/assets/images/elements/dont-leave-subscription.svg"
      class="ml-auto mr-auto mb-4"
    >
    <p class="mb-4">
      Your plan is currently on our old pricing scheme,
      <b>meaning you’re paying less than new users.</b>
    </p>
    <p class="mb-4">
      If you cancel your plan and buy a new one, you’ll pay the updated price.
    </p>
    <p>Are you sure you want to continue?</p>
    <template #action>
      <aha-button
        @click="handleCancelButton"
        has-margin-right
      >
        Stay
      </aha-button>
      <aha-link
        :disabled="loadingConfirmRemoveCard"
        @click="handleOKButton"
      >
        <span class="font-bold">Continue</span>
        <aha-spinner
          variant="dark"
          size="xs"
          class="ml-1"
          v-if="loadingConfirmRemoveCard"
        />
      </aha-link>
    </template>
    <div class="m-2 text-center text-red-100" v-if="error">
      Something went wrong, please contact us for support
    </div>
  </aha-modal>
</template>
<script>
import * as Sentry from '@sentry/vue'
import storageKeys from '@/constant/storageKeys'
import Config from '@/config'
import stripeApi from '@/api/stripe'
import Util from '@/util'

export default {
  name: 'RemoveCardInfo',
  props: {
    currentUserPlan: {
      type: Object,
      default: () => ({}),
    },
    currentSubscription: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingConfirmRemoveCard: false,
      error: false,
      visible: false,
      data: {},
    }
  },
  computed: {
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
  },
  mounted() {
    this.visible = true
  },
  methods: {
    handleOKButton() {
      if (this.currentUserPlan.group === 'one-time') {
        this.handleOKButtonOneTime()
        return
      }
      if (this.currentSubscription && this.currentSubscription.subscription.cancel_at_period_end) {
        this._removeCardInfo()
        return
      }
      localStorage.setItem(storageKeys.IS_REMOVE_CARD_PURPOSE, true)
      this.$router.push({ name: 'UserCancelSub' })
    },

    handleOKButtonOneTime() {
      if (this.loadingConfirmRemoveCard) return
      this.error = false
      this._removeCardInfo()
      Util.gaTrackEvent(
        'User Plan',
        'User remove card info',
        'User click on OK remove card info',
      )
    },
    handleCancelButton() {
      this.visible = false
      this.$emit('handleCancelRemoveCardInfo')
    },
    async _removeCardInfo() {
      this.loadingConfirmRemoveCard = true

      try {
        const { body: { ref } } = await stripeApi.removeCards()
        await this._turnOffAutoRenew(ref)
        this.$emit('handleRemoveCardInfo', this.data)
        this.loadingConfirmRemoveCard = false
      } catch {
        this.error = true
        this.loadingConfirmRemoveCard = false
      }
    },
    async _turnOffAutoRenew(ref) {
      try {
        await this.$http.post(Config.api.changeSubscription, {
          stop: true,
          ref,
        })
      } catch (err) {
        Sentry.captureException(err)
      }
    },
  },
}
</script>
